export const LAYOUT_CONFIG = {
    viewPermission: 'AdministrationService.Layout',
    createPermission: 'AdministrationService.Layout.Create',
    editPermission: 'AdministrationService.Layout.Edit',
    deletePermission: 'AdministrationService.Layout.Delete',
    editBasicLayoutPermission: 'AdministrationService.Layout.EditBasic'
}